import { useDisplayStore, useSystemStore } from '../../../store/sceneStore';

function DevelopWidget() {
	const { data: display, setState: setDisplay } = useDisplayStore((s) => s);
	const system = useSystemStore();

	const _onClickToggleInfo = () => {
		setDisplay({ ...display, info: !display.info });
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<button
				type='button'
				className='developerButton'
				style={{
					backgroundColor: 'rgba(0,0,0,0)',
					fontSize: '30px',
					width: '20%',
				}}
				onClick={_onClickToggleInfo}
				disabled={false}
			>
				{system.status}
			</button>
			<div
				className={`Modal Show`}
				style={{
					// top: "8em",

					marginLeft: '1.5em',
					overflow: 'scroll',
					scrollbarWidth: '0',
					position: 'relative',
					width: `${display.mode && display.info ? '35%' : '0%'}`,
					height: `${display.mode && display.info ? '50%' : '0%'}`,
					borderTopRightRadius: '20px',
					borderBottomLeftRadius: '20px',
					borderBottomRightRadius: '20px',
					backgroundColor: 'rgba(255,255,255,0.4)',
					transition: 'all 0.5s ease-in-out',
					paddingBottom: '1em',
				}}
			>
				<p style={{ fontWeight: 'bold', marginTop: '1em', marginLeft: '1em' }}>
					{display.mode && display.info ? '[Log Messages]' : ''}
				</p>
				{display.mode && display.info
					? system.status_text.split('\n').map((it, i) => (
							<div key={'x' + i} style={{ marginLeft: '1em' }}>
								{it}
							</div>
						))
					: ''}
			</div>
		</div>
	);
}
export default DevelopWidget;
